import {TimelineMax, Cubic} from 'gsap'
import morphSVG from '../vendor/MorphSVGPlugin'
import _ from 'lodash'

export default (template, timelinemaster) => {
  return {
    template: template,
    props: {
      image: String,
      transparent: Boolean,
      size: {
        type: String,
        default: 'full'
      },
      color: {
        type: String,
        validator: value => {
          return value === 'gradient' || value === 'dark' || value === ''
        }
      },
      darkstroke: Boolean
    },
    data: () => ({
      id: 'Decor0',
      element: null,
      timelinestroke: null,
      timelineshape: null,
      animation: {
        speed: 4, // length of time it takes to complete a cycle
        ease: Cubic.easeInOut, // ease style //https://greensock.com/docs/Easing
        delay: 0, // timing between animations
        repeat: -1 // -1 means infinite
      },
      canplay: true
    }),
    mounted () {
      this.$store.dispatch('decor/create', {})
        .then((which) => {
          // returns the 'id' of the newly created panel item
          this.element = this.$el
          this.id = which
          this.buildSVG()
        })
        .then(() => {
          this.playSVG()
        })
    },
    watch: {
    },
    computed: {
      hasimage () {
        return this.image
      },
      useclippath () {
        return this.hasimage
      },
      istransparent () {
        return this.transparent
      },
      hasdarkstroke () {
        return this.darkstroke
      },
      isgradient () {
        return !this.image && this.color === 'gradient'
      },
      isdark () {
        return this.color === 'dark'
      },
      islarge () {
        return this.largebubble
      }
    },
    methods: {
      getId (base, prefix) {
        base = (_.isString(base)) ? '-' + base : ''
        prefix = (_.isString(prefix)) ? prefix : ''
        return prefix + this.id + base
      },
      getGradientFill (base) {
        return (this.isgradient) ? 'url(' + this.getId(base, '#') + ')' : null
      },
      playSVG () {
        if (this.canplay) this.timelineshape.play()
        if (this.canplay) this.timelinestroke.play()
      },
      imageStyle () {
        let style = {}
        if (this.image) {
          let url = this.getId('ClipPath', '#')
          style = 'clip-path: url(' + url + ');'
        }

        return style
      },
      buildSVG () {
        if (!this.canplay) return

        const settings = this.animation

        const shape1 = this.$refs.shape1
        const shape2 = this.$refs.shape2
        const shape3 = this.$refs.shape3
        const shape4 = this.$refs.shape4

        const line1 = this.$refs.stroke1
        const line2 = this.$refs.stroke2
        const line3 = this.$refs.stroke3
        const line4 = this.$refs.stroke4

        this.timelineshape = new TimelineMax({ repeat: settings.repeat, delay: 0, paused: true })

        this.timelineshape.startTime(0)

        this.timelineshape
          .to(shape1, settings.speed, { ease: settings.ease, morphSVG: {shape: shape2} }, 0)
          .to(line1, settings.speed, { ease: settings.ease, morphSVG: {shape: line2} }, 0)
          .to(shape1, settings.speed, { ease: settings.ease, morphSVG: {shape: shape3} }, settings.speed * 1)
          .to(line1, settings.speed, { ease: settings.ease, morphSVG: {shape: line3} }, settings.speed * 1)
          .to(shape1, settings.speed, { ease: settings.ease, morphSVG: {shape: shape4} }, settings.speed * 2)
          .to(line1, settings.speed, { ease: settings.ease, morphSVG: {shape: line4} }, settings.speed * 2)
          .to(shape1, settings.speed, { ease: settings.ease, morphSVG: {shape: shape1}, yoyo: true }, settings.speed * 3)
          .to(line1, settings.speed, { ease: settings.ease, morphSVG: {shape: line1}, yoyo: true }, settings.speed * 3)
      }
    }
  }
}



// WEBPACK FOOTER //
// ./assets/js/components/morphbubble.js